import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/listings/[listingId]/listing-detail-page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/listing/components/listing-detailed/listing-detailed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/listing/components/listing-not-found/listing-not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/listing/components/listings-infinity-scroll/listings-infinity-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/divider/divider.module.scss");
